import { SVGProps } from 'react';

const SvgPrescription = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M24 0C10.7 0 0 10.7 0 24v272c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h78.1l128 128L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L407 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L441 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-95.3-95.3c53.8-8.1 95.2-54.6 95.2-110.8C288 50.1 237.9 0 176 0H24zm152 176H48V48h128c35.3 0 64 28.7 64 64s-28.7 64-64 64z" />
  </svg>
);
export default SvgPrescription;
